document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  const selectors = {
    triggerFilter: '.js-open-filter-drawer',
    closeFilter: '.js-close-filter-drawer',
    drawer: '#SmartFilterDrawer',
    backdrop: '.sc-drawer-backdrop',
    filterForm: '#FacetFiltersForm',
    productGrid: '#ProductGridContainer',
    filterFooter: '.sc-drawer__footer',
    toolbarCount: '.js-toolbar-count',
    clearAll: '.js-clear-all',
    loadMoreBtn: '.js-load-more',
    loadMoreContainer: '.smart-load-more-container',
    loader: '.smart-loader',
    productCard: '.smart-card',
    triggerModal: '.js-open-desc-modal',
    closeModal: '.js-close-desc-modal',
    modal: '#DescModal',
    gridContainer: '.smart-grid-container',
    toggles: '.sc-toggle-btn',
    modeExplorerBtn: '.js-mode-explorer',
    quickViewBtn: '.quick-view-btn'
  };

  const cardObserver = new ResizeObserver(entries => {
    const isMobileViewport = window.innerWidth < 768;
    entries.forEach(entry => {
      const card = entry.target;
      if (isMobileViewport && entry.contentRect.width < 340) {
        card.classList.add('is-compact-layout');
      } else {
        card.classList.remove('is-compact-layout');
      }
    });
  });

  function refreshCardLayouts() {
    const cards = document.querySelectorAll(selectors.productCard);
    cards.forEach(card => cardObserver.observe(card));
    updateOrphanCards();
  }

  function updateOrphanCards() {
    const grid = document.querySelector(selectors.gridContainer);
    if (!grid) return;

    grid.querySelectorAll('.is-orphan').forEach(el => el.classList.remove('is-orphan'));

    const allCards = Array.from(grid.querySelectorAll('.smart-card, .smart-card--promo'));
    const availableCards = allCards.filter(card => !card.classList.contains('is-soldout'));
    const soldoutCards = allCards.filter(card => card.classList.contains('is-soldout'));

    if (availableCards.length % 2 !== 0) {
      availableCards[availableCards.length - 1].classList.add('is-orphan');
    }

    if (soldoutCards.length % 2 !== 0) {
      soldoutCards[soldoutCards.length - 1].classList.add('is-orphan');
    }
  }

  function toggleBodyScroll(lock) {
    if (lock) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
  }

  const drawer = document.querySelector(selectors.drawer);
  const backdrop = document.querySelector(selectors.backdrop);

  function toggleDrawer(open) {
    if (!drawer || !backdrop) return;
    if (open) {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      toggleBodyScroll(true);
    } else {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      toggleBodyScroll(false);
    }
  }

  document.querySelectorAll(selectors.triggerFilter).forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      toggleDrawer(true);
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest(selectors.closeFilter) || e.target.matches(selectors.backdrop)) {
      e.preventDefault();
      toggleDrawer(false);
    }
  });

  function initModeExplorer() {
    const explorerBtn = document.querySelector(selectors.modeExplorerBtn);
    if (explorerBtn) {
      const newBtn = explorerBtn.cloneNode(true);
      explorerBtn.parentNode.replaceChild(newBtn, explorerBtn);

      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        toggleDrawer(false);
        const firstProduct = document.querySelector(selectors.productCard);
        if (firstProduct) {
          const quickViewTrigger = firstProduct.querySelector(selectors.quickViewBtn);
          if (quickViewTrigger) {
            setTimeout(() => {
              quickViewTrigger.click();
            }, 300);
          }
        }
      });
    }
  }

  const modal = document.querySelector(selectors.modal);
  if (modal) {
    document.body.addEventListener('click', (e) => {
      if (e.target.closest(selectors.triggerModal)) {
        e.preventDefault();
        modal.classList.add('is-open');
        toggleBodyScroll(true);
      }
      if (e.target.closest(selectors.closeModal) || e.target === modal) {
        e.preventDefault();
        modal.classList.remove('is-open');
        toggleBodyScroll(false);
      }
    });
  }

  const filterForm = document.querySelector(selectors.filterForm);
  const productGrid = document.querySelector(selectors.productGrid);

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function initAfterAjax() {
    reapplyGridState(); 
    initLoadMore();
    initProductCards();
    initModeExplorer();
    refreshCardLayouts(); 
  }

  function fetchAndRender(url) {
    if(productGrid) productGrid.style.opacity = '0.5';
    
    const ctaBtn = document.querySelector('.sc-btn-apply');
    if(ctaBtn) ctaBtn.classList.add('is-loading');

    history.pushState(null, '', url);

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        const newProductGrid = html.querySelector(selectors.productGrid);
        if (productGrid && newProductGrid) {
          productGrid.innerHTML = newProductGrid.innerHTML;
          productGrid.style.opacity = '1';
        }

        const newFilterForm = html.querySelector(selectors.filterForm);
        const currentFilterForm = document.querySelector(selectors.filterForm);
        if (currentFilterForm && newFilterForm) {
          currentFilterForm.innerHTML = newFilterForm.innerHTML;
        }

        const newFooter = html.querySelector(selectors.filterFooter);
        const currentFooter = document.querySelector(selectors.filterFooter);
        if (currentFooter && newFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
        }

        const newToolbarCount = html.querySelector(selectors.toolbarCount);
        const currentToolbarCount = document.querySelector(selectors.toolbarCount);
        if (currentToolbarCount && newToolbarCount) {
           currentToolbarCount.replaceWith(newToolbarCount); 
        }

        initAfterAjax();
        
        if(ctaBtn) ctaBtn.classList.remove('is-loading');
      })
      .catch(err => {
        if(productGrid) productGrid.style.opacity = '1';
        if(ctaBtn) ctaBtn.classList.remove('is-loading');
      });
  }

  if (filterForm) {
    filterForm.addEventListener('input', debounce((event) => {
      if(event.target.type === 'number') return; 
      const formData = new FormData(filterForm);
      const searchParams = new URLSearchParams(formData).toString();
      const url = `${window.location.pathname}?${searchParams}`;
      fetchAndRender(url);
    }, 500));
  }

  document.addEventListener('click', (e) => {
    if (e.target.matches(selectors.clearAll)) {
      e.preventDefault();
      fetchAndRender(e.target.href);
    }
  });

  function initLoadMore() {
    const loadMoreBtn = document.querySelector(selectors.loadMoreBtn);
    const gridContainer = document.querySelector(selectors.gridContainer);

    if (loadMoreBtn && gridContainer) {
      const newBtn = loadMoreBtn.cloneNode(true);
      loadMoreBtn.parentNode.replaceChild(newBtn, loadMoreBtn);

      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        const btn = this;
        const url = btn.getAttribute('data-next-url');
        if (!url) return;

        btn.classList.add('is-loading');
        const loader = btn.querySelector(selectors.loader);
        if(loader) loader.style.display = 'inline-block';

        fetch(url)
          .then(res => res.text())
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');
            const newItems = Array.from(html.querySelectorAll(selectors.productCard + ', .smart-card--promo'));
            const btnContainer = document.querySelector(selectors.loadMoreContainer);

            newItems.forEach(item => {
              if (btnContainer && btnContainer.parentNode === gridContainer) {
                gridContainer.insertBefore(item, btnContainer);
              } else {
                gridContainer.appendChild(item);
              }
            });

            const nextBtnHTML = html.querySelector(selectors.loadMoreBtn);
            if (nextBtnHTML && nextBtnHTML.hasAttribute('data-next-url')) {
               btn.setAttribute('data-next-url', nextBtnHTML.getAttribute('data-next-url'));
            } else {
               if(btnContainer) btnContainer.remove();
               else btn.remove();
               gridContainer.classList.add('all-products-loaded');
            }

            btn.classList.remove('is-loading');
            if(loader) loader.style.display = 'none';
            
            initProductCards();
            refreshCardLayouts(); 
          })
          .catch(err => {
            btn.classList.remove('is-loading');
          });
      });
    }
  }
  
  function updateToggleState(clickedBtn) {
    if (!clickedBtn) return; // Sécurité si le bouton n'existe pas dans le DOM actuel
    const parent = clickedBtn.closest('.sc-grid-toggles');
    if(parent) {
      parent.querySelectorAll(selectors.toggles).forEach(b => b.classList.remove('is-active'));
      clickedBtn.classList.add('is-active');
    }
  }

  function getActiveGrid() {
    return document.querySelector(selectors.gridContainer);
  }

  document.querySelectorAll('.js-grid-1').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const grid = getActiveGrid();
      if(grid) grid.classList.add('is-one-column');
      updateToggleState(btn);
      localStorage.setItem('sc-grid-mobile', '1');
      setTimeout(() => refreshCardLayouts(), 100);
    });
  });

  document.querySelectorAll('.js-grid-2').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const grid = getActiveGrid();
      if(grid) grid.classList.remove('is-one-column'); 
      updateToggleState(btn);
      localStorage.setItem('sc-grid-mobile', '2');
      setTimeout(() => refreshCardLayouts(), 100);
    });
  });

  function reapplyGridState() {
     // Force par défaut à '2' pour mobile
     const mobilePref = localStorage.getItem('sc-grid-mobile') || '2';
     const grid = getActiveGrid();
     
     if(grid) {
        if(mobilePref === '1') {
           grid.classList.add('is-one-column');
           updateToggleState(document.querySelector('.js-grid-1'));
        } else {
           grid.classList.remove('is-one-column');
           updateToggleState(document.querySelector('.js-grid-2'));
        }
     }
  }

  function initProductCards() {
    document.querySelectorAll('.js-toggle-variants').forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });
    
    document.querySelectorAll('.js-toggle-variants').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const card = this.closest('.smart-card');
        const drawer = card.querySelector('.smart-card__variants-drawer');

        if(drawer) {
          document.querySelectorAll('.smart-card.drawer-is-open').forEach(c => {
            if(c !== card) c.classList.remove('drawer-is-open');
          });
          card.classList.add('drawer-is-open');
        }
      });
    });

    document.querySelectorAll('.js-close-variants').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const card = this.closest('.smart-card');
        if(card) card.classList.remove('drawer-is-open');
      });
    });
  }

  initLoadMore();
  reapplyGridState();
  initProductCards();
  initModeExplorer();
  refreshCardLayouts(); 
});